import axios from "axios";
import api from "./api";

/**
 * One file into the portal: ask the server for a signed URL, PUT the file
 * straight to storage, tell the server it is there.
 *
 * The PUT is sent without our cookies — it goes to the storage's own domain —
 * and with exactly the headers the server signed. Storage may take a moment to
 * report a new object, so "not arrived yet" (409) is retried once.
 * `completeBase` is where the upload is finished: the portal's, or the
 * admin's for a file the team uploads (`/admin/portal/files`).
 */
export async function uploadFile(startPath, file, { onProgress, completeBase = "/portal/files", extra = {} } = {}) {
  const start = await api.post(startPath, { ...extra, name: file.name, size: file.size, content_type: file.type || "" });
  const { upload, file: row } = start.data;
  await axios.put(upload.url, file, {
    headers: upload.headers,
    withCredentials: false,
    onUploadProgress: (e) => e.total && onProgress?.(Math.round((e.loaded / e.total) * 100)),
  });
  try {
    return (await api.post(`${completeBase}/${row.id}/complete`)).data.file;
  } catch (err) {
    if (err?.response?.status !== 409) throw err;
    await new Promise((r) => setTimeout(r, 1500));
    return (await api.post(`${completeBase}/${row.id}/complete`)).data.file;
  }
}

/** The sentence to show when an upload failed: the server's, or the network's. */
export function uploadErrorText(err, apiErrorMessage) {
  return err?.response
    ? apiErrorMessage(err, "Fișierul nu s-a putut încărca.")
    : "Fișierul nu s-a putut trimite. Verifică conexiunea și încearcă din nou.";
}
